const getTargetProgressPercent = (targetProgress = {}) => {
  const { bytesSent = 0, totalBytes = 0 } = targetProgress;
  if (totalBytes <= 0) return 0;

  return Math.min(100, Math.max(0, (bytesSent / totalBytes) * 100));
};

export const getUpgradeProgressPercent = (
  progressByTarget,
  upgradeTargets
) => {
  if (upgradeTargets.length === 0) return 0;

  const combinedPercent = upgradeTargets.reduce(
    (total, key) => total + getTargetProgressPercent(progressByTarget[key]),
    0
  );

  return Math.round(combinedPercent / upgradeTargets.length);
};
